import axios from 'axios'
import ViewUI from 'view-design'
import { MessagePlugin } from 'tdesign-vue'
import envConst from '../const'
import logoutHandler from '../assets/js/logoutHandler'

const DEFAULT_API_ERROR_MESSAGE = '接口请求失败，请稍后重试'
const SESSION_EXPIRED_MESSAGE =
  '您的登录状态已过期，为保障账户安全，请重新登录。'

let sessionExpiredDialogVisible = false

function getErrorMessage(data, fallback = DEFAULT_API_ERROR_MESSAGE) {
  if (typeof data === 'string' && data.trim()) {
    return data
  }

  if (data && typeof data === 'object') {
    const message = data.message || data.error || data.msg
    if (typeof message === 'string' && message.trim()) {
      return message
    }
  }

  return fallback
}

function showApiError(message) {
  // MessagePlugin.error 与组件内的 this.$message.error 是同一套全局提示。
  MessagePlugin.error({
    content: message,
    duration: 4000,
    closeBtn: true,
    placement: 'top',
  })
}

function createApiError(message, response, originalError) {
  const error = originalError instanceof Error ? originalError : new Error(message)
  error.message = message
  error.isApiError = true
  if (response) {
    error.response = response
  }
  return error
}

function isLoginRequest(config) {
  if (!config || typeof config.url !== 'string') {
    return false
  }
  return config.url.split('?')[0].replace(/\/$/, '').endsWith('/login')
}

function rejectSessionExpired(response, originalError) {
  if (!sessionExpiredDialogVisible) {
    sessionExpiredDialogVisible = true
    ViewUI.Modal.warning({
      title: '登录状态已失效',
      content: SESSION_EXPIRED_MESSAGE,
      okText: '确定',
      closable: false,
      maskClosable: false,
      onOk: () => {
        localStorage.removeItem('errorMessage')
        logoutHandler()
      },
    })
  }
  return Promise.reject(
    createApiError(SESSION_EXPIRED_MESSAGE, response, originalError)
  )
}

axios.defaults.baseURL = envConst.API_ORIGIN
axios.interceptors.request.use(function(config) {
  localStorage.token && (config.headers.Authorization = localStorage.token)
  return config
})
axios.interceptors.request.use(
  config => {
    ViewUI.LoadingBar.start()
    return config
  },
  () => {
    ViewUI.LoadingBar.error()
  }
)
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    ViewUI.LoadingBar.finish()
    if (response.data instanceof Blob || response.config.url.indexOf('shy/export') >0) {
      return Promise.resolve(response)
    }
    if (response.config.url.indexOf('/dashboard/productHot') !== -1) {
      return Promise.resolve(response.data)
    }
    switch (response.data.code) {
      case 200:
        return Promise.resolve(response.data.data)
      case 401:
      case 403:
        if (isLoginRequest(response.config)) {
          const message = getErrorMessage(response.data)
          showApiError(message)
          return Promise.reject(createApiError(message, response))
        }
        return rejectSessionExpired(response)
      default: {
        const message = getErrorMessage(response.data)
        showApiError(message)
        return Promise.reject(createApiError(message, response))
      }
    }
  },
  error => {
    ViewUI.LoadingBar.error()
    let message
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
          if (!isLoginRequest(error.config || error.response.config)) {
            return rejectSessionExpired(error.response, error)
          }
          message = getErrorMessage(error.response.data)
          break
        case 404:
          message = getErrorMessage(error.response.data, '请求的接口不存在')
          break
        case 500:
          message = getErrorMessage(error.response.data, '服务器出现故障，请联系管理员')
          break
        case 502:
          message = '服务器正在维护，请稍后重试'
          break
        default:
          message = getErrorMessage(
            error.response.data,
            `接口请求失败（${error.response.status}）`
          )
      }
    } else if (error.code === 'ECONNABORTED') {
      message = '接口请求超时，请稍后重试'
    } else {
      message = '网络连接异常，请检查网络后重试'
    }

    showApiError(message)
    return Promise.reject(createApiError(message, error.response, error))
  }
)
export default axios
